import { Type } from 'class-transformer';
import { BasketPriceModel } from './BasketPriceModel';

export class LinkedSofaglideModel {
    public baseProductCode: string;
    public crossSellingProductCode: string;
    public entryNumber: number;
    public quantity: number;

    @Type(() => BasketPriceModel)
    public price: BasketPriceModel;
}